<template>
  <div class="m-card card-gradient">
    <h4 class=" tb_700">Today total manhour</h4>
    <div class="content">
      <div class="chart">
        <DonutChart :chartOptions="chartOptions" :series="series" />
        <h4 class="text-center-chart tb_700">{{((series[0]/(series[1]))*100).toFixed(1)}}%</h4>
      </div>
      <div class="layout-text ">
        <h3 class="tb_700">{{series[0]}} / {{series[1]}}</h3>
        <span class="hours tb_700">HOURS</span>
      </div>
    </div>
  </div>
</template>

<script>
import DonutChart from "@/components/ApexChart/DonutChart.vue";

export default {
  components: { DonutChart, },
  props: {
    series: Array,
    colors:Array,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "donut",
        },
        labels: ["Active", "Inactive"],
        colors: ['#79b048', '#dcf2ce'],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>

.content {
  display: grid;
  grid: auto/150px auto;
  .layout-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
}
 .card-gradient {
  background: linear-gradient(
    180deg,
    #79b048 0%,
    var(--background-color-sidebar) 45px,
    var(--background-color-sidebar) 100%
  );
}

.chart {
  position: relative;
}
.text-center-chart {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.tb_700{
  font-weight: 700;
color: var(--text-color-2);
}

.hours{
  background-color:#79b048 ;
  padding: 0.2rem;
  border-radius: 0.3rem;
}
</style>